import React from "react";
import GroupList from "components/common/dl_group/GroupList/GroupList";
import { DL_GROUP_DESCRIPTION } from "constant/dl_group/dl_group_description.constant";

const CitajteoStart: React.FC = () => {
  return <GroupList groupsData={Object.values(DL_GROUP_DESCRIPTION)} />;
};

export default CitajteoStart;
